// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.margin-t6 {
	margin-top: 6rem;
}
.margin-t10 {
	margin-top: 10rem;
}
.margin-t12 {
	margin-top: 12rem;
}
.margin-t13 {
	margin-top: 13rem;
}
.margin-t14 {
	margin-top: 14rem;
}

.flex-column {
	display: flex;
	flex-direction: column;
	width: 100%;
}
.flex-row {
	display: flex;
	flex-direction: row;
	width: 90%;
	/* margin: 1rem */
}

.primary1 {
	background-color: var(--primary-color1);
}
.font-p1 {
	color: var(--primary-color1);
}
.font-p2 {
	color: var(--primary-color2);
}
.primary2 {
	background-color: var(--primary-color2);
}
.float-fg1 {
	color: var(--www-color-float-fg1);
}
.float-bg {
	background-color: var(--www-color-float-bg1);
}
.float-bg2 {
	background-color: var(--www-color-float-bg2);
}
.meteo-text {
	color: var(--meteo-text);
}
.secondary1 {
	background-color: var(--secondary-color1);
}
.justify-top {
	justify-content: flex-start;
}
.lh-small {
	line-height: 1.4rem;
}
.lh-medium {
	line-height: 1.6rem;
}
.lh-large {
	line-height: 1.8rem;
}
.secondary2 {
	background-color: var(--secondary-color2);
}
.space-between {
	justify-content: space-between;
}
.text-12 {
	font-size: 1.2rem;
}
.text-14 {
	font-size: 1.4rem;
}
.text-16 {
	font-size: 1.6rem;
}
.center-h {
	align-items: center;
}
.pad1 {
	padding: 1rem;
	overflow: hidden;
}
.center-rh {
	justify-content: center;
}
.full-width {
	width: 100%;
}
.fixed {
	position: fixed;
}
.relative {
	position: relative;
}
.center-v {
	align-items: center;
}
.from-left {
	animation: slideInLeft 0.2s ease-in-out forwards;
}
.flex-grow {
	flex-grow: 1;
}
.small-text p {
	font-size: 1.2rem;
}
.mb10 {
	margin-bottom: 10px;
}
.br5 {
	border-radius: 5px;
}
.scroll-y {
	overflow-y: scroll;
}
.br-10{
	border-radius:10px
}

.from-right {
	animation: slideInRight 0.2s ease-in-out forwards;
}

.full-width {
	width: 100%;
}
.wrap {
	flex-wrap: wrap;
}
.full-height {
	height: 100%;
}
@keyframes slideInLeft {
	from {
		left: -50%;
		top: -25%;
	}
	to {
		left: 0;
		top: 0;
	}
}
@keyframes slideInRight {
	from {
		right: -50%;
		top: -25%;
	}
	to {
		right: 0;
		top: 0;
	}
}

.divide-equal {
	flex-basis: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ApiWelcomePage/base-styles.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;AACZ;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,UAAU;CACV,iBAAiB;AAClB;;AAEA;CACC,uCAAuC;AACxC;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,uCAAuC;AACxC;AACA;CACC,iCAAiC;AAClC;AACA;CACC,4CAA4C;AAC7C;AACA;CACC,4CAA4C;AAC7C;AACA;CACC,wBAAwB;AACzB;AACA;CACC,yCAAyC;AAC1C;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,yCAAyC;AAC1C;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,aAAa;CACb,gBAAgB;AACjB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,WAAW;AACZ;AACA;CACC,eAAe;AAChB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,gDAAgD;AACjD;AACA;CACC,YAAY;AACb;AACA;CACC,iBAAiB;AAClB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC;AACD;;AAEA;CACC,iDAAiD;AAClD;;AAEA;CACC,WAAW;AACZ;AACA;CACC,eAAe;AAChB;AACA;CACC,YAAY;AACb;AACA;CACC;EACC,UAAU;EACV,SAAS;CACV;CACA;EACC,OAAO;EACP,MAAM;CACP;AACD;AACA;CACC;EACC,WAAW;EACX,SAAS;CACV;CACA;EACC,QAAQ;EACR,MAAM;CACP;AACD;;AAEA;CACC,eAAe;AAChB","sourcesContent":[".margin-t6 {\n\tmargin-top: 6rem;\n}\n.margin-t10 {\n\tmargin-top: 10rem;\n}\n.margin-t12 {\n\tmargin-top: 12rem;\n}\n.margin-t13 {\n\tmargin-top: 13rem;\n}\n.margin-t14 {\n\tmargin-top: 14rem;\n}\n\n.flex-column {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n}\n.flex-row {\n\tdisplay: flex;\n\tflex-direction: row;\n\twidth: 90%;\n\t/* margin: 1rem */\n}\n\n.primary1 {\n\tbackground-color: var(--primary-color1);\n}\n.font-p1 {\n\tcolor: var(--primary-color1);\n}\n.font-p2 {\n\tcolor: var(--primary-color2);\n}\n.primary2 {\n\tbackground-color: var(--primary-color2);\n}\n.float-fg1 {\n\tcolor: var(--www-color-float-fg1);\n}\n.float-bg {\n\tbackground-color: var(--www-color-float-bg1);\n}\n.float-bg2 {\n\tbackground-color: var(--www-color-float-bg2);\n}\n.meteo-text {\n\tcolor: var(--meteo-text);\n}\n.secondary1 {\n\tbackground-color: var(--secondary-color1);\n}\n.justify-top {\n\tjustify-content: flex-start;\n}\n.lh-small {\n\tline-height: 1.4rem;\n}\n.lh-medium {\n\tline-height: 1.6rem;\n}\n.lh-large {\n\tline-height: 1.8rem;\n}\n.secondary2 {\n\tbackground-color: var(--secondary-color2);\n}\n.space-between {\n\tjustify-content: space-between;\n}\n.text-12 {\n\tfont-size: 1.2rem;\n}\n.text-14 {\n\tfont-size: 1.4rem;\n}\n.text-16 {\n\tfont-size: 1.6rem;\n}\n.center-h {\n\talign-items: center;\n}\n.pad1 {\n\tpadding: 1rem;\n\toverflow: hidden;\n}\n.center-rh {\n\tjustify-content: center;\n}\n.full-width {\n\twidth: 100%;\n}\n.fixed {\n\tposition: fixed;\n}\n.relative {\n\tposition: relative;\n}\n.center-v {\n\talign-items: center;\n}\n.from-left {\n\tanimation: slideInLeft 0.2s ease-in-out forwards;\n}\n.flex-grow {\n\tflex-grow: 1;\n}\n.small-text p {\n\tfont-size: 1.2rem;\n}\n.mb10 {\n\tmargin-bottom: 10px;\n}\n.br5 {\n\tborder-radius: 5px;\n}\n.scroll-y {\n\toverflow-y: scroll;\n}\n.br-10{\n\tborder-radius:10px\n}\n\n.from-right {\n\tanimation: slideInRight 0.2s ease-in-out forwards;\n}\n\n.full-width {\n\twidth: 100%;\n}\n.wrap {\n\tflex-wrap: wrap;\n}\n.full-height {\n\theight: 100%;\n}\n@keyframes slideInLeft {\n\tfrom {\n\t\tleft: -50%;\n\t\ttop: -25%;\n\t}\n\tto {\n\t\tleft: 0;\n\t\ttop: 0;\n\t}\n}\n@keyframes slideInRight {\n\tfrom {\n\t\tright: -50%;\n\t\ttop: -25%;\n\t}\n\tto {\n\t\tright: 0;\n\t\ttop: 0;\n\t}\n}\n\n.divide-equal {\n\tflex-basis: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
